import React from 'react';
import styles from '../../css/wheater.module.css'

import { 
  WiDaySunny, WiDaySunnyOvercast, WiSprinkle, WiRain, WiRainMix, WiSnow, 
  WiStormShowers, WiDaySnowWind, WiNightAltSnowWind, WiDaySprinkle, WiNightAltSprinkle
} from "react-icons/wi";
import { BsCloudSleet,  BsCloudSnow,  BsClouds, BsCloudMoon, BsCloudFog } from "react-icons/bs";
import { IoPartlySunnyOutline, IoThunderstormOutline  } from "react-icons/io5";
import { BiCloudSnow } from "react-icons/bi";
import { LiaCloudSunRainSolid, LiaCloudMoonRainSolid, LiaCloudMoonSolid, LiaCloudShowersHeavySolid } from "react-icons/lia";
import { MdOutlineThunderstorm } from "react-icons/md";
import { PiMoonStars } from "react-icons/pi";
import { FiSunrise, FiSunset } from "react-icons/fi";
import { FaTemperatureArrowDown, FaTemperatureArrowUp, FaTemperatureEmpty, FaTemperatureFull, FaTemperatureQuarter } from "react-icons/fa6";
import { GiSunRadiations, GiWindsock } from "react-icons/gi";
import { TfiRuler } from "react-icons/tfi";

import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { LuPickaxe } from "react-icons/lu";
import { TbTemperatureSnow, TbTemperatureSun } from "react-icons/tb";



const View = ({data, namePlaceRef})=>{

const [openDay, setOpenDay] = useState(null);
const [prevOpenDay, setPrevOpenDay] = useState(null);

const dayRefs =  useRef([])


// w środku komponentu View
useEffect(() => {
  // resetujemy otwarty dzień za każdym razem, gdy zmienia się data
  setOpenDay(null);
  setPrevOpenDay(null);

}, [data]);


const weatherIconsDay = 
{
    0: <WiDaySunny style={{ fontSize: '2.5rem'}} />,
    1: <WiDaySunnyOvercast style={{ fontSize: '2.5rem'}} />,
    2: <IoPartlySunnyOutline  style={{ fontSize: '2.5rem'}} />,
    3: <BsClouds style={{ fontSize: '2.5rem'}} />,
    45: <BsCloudFog style={{ fontSize: '2.5rem'}} />,
    48: <BsCloudFog style={{ fontSize: '2.5rem'}} />,
    51: <WiDaySprinkle style={{ fontSize: '2.5rem'}} />,
    53: <WiDaySprinkle style={{ fontSize: '2.5rem'}} />,
    55: <WiSprinkle style={{ fontSize: '2.5rem'}} />,
    56: <BsCloudSleet style={{ fontSize: '2.5rem'}} />,
    57: <BsCloudSleet style={{ fontSize: '2.5rem'}} />,
    61: <WiRain style={{ fontSize: '2.5rem'}} />,
    63: <WiRain style={{ fontSize: '2.5rem'}} />,
    65: <WiRain style={{ fontSize: '2.5rem'}} />,
    66: <WiRainMix style={{ fontSize: '2.5rem'}} />,
    67: <WiRainMix style={{ fontSize: '2.5rem'}} />,
    68: <BsCloudSleet style={{ fontSize: '2.5rem'}} />,
    69: <BsCloudSleet style={{ fontSize: '2.5rem'}} />,
    71: <WiSnow style={{ fontSize: '2.5rem'}} />,
    73: <BiCloudSnow style={{ fontSize: '2.5rem'}} />,
    75: <BsCloudSnow  style={{ fontSize: '2.5rem'}} />,
    77: <BsCloudSnow  style={{ fontSize: '2.5rem'}} />,
    80: <LiaCloudSunRainSolid style={{ fontSize: '2.5rem'}} />,
    81: <LiaCloudSunRainSolid style={{ fontSize: '2.5rem'}} />,
    82: <LiaCloudShowersHeavySolid style={{ fontSize: '2.5rem'}} />,
    85: <WiDaySnowWind  style={{ fontSize: '2.5rem'}} />,
    86: <WiDaySnowWind style={{ fontSize: '2.5rem'}} />,
    95: <MdOutlineThunderstorm style={{ fontSize: '2.5rem'}} />,
    96: <WiStormShowers style={{ fontSize: '2.5rem'}} />,
    99: <IoThunderstormOutline  style={{ fontSize: '2.5rem'}} />
};


const dayToNight = {
  0: <PiMoonStars style={{ fontSize: '2.5rem'}} /> ,
  1: <BsCloudMoon style={{ fontSize: '2.5rem'}} />,
  2: <LiaCloudMoonSolid style={{ fontSize: '2.5rem'}} />,
  51: <WiNightAltSprinkle style={{ fontSize: '2.5rem'}} />,
  53: <WiNightAltSprinkle style={{ fontSize: '2.5rem'}} />,
  80: <LiaCloudMoonRainSolid style={{ fontSize: '2.5rem'}} />,
  81: <LiaCloudMoonRainSolid style={{ fontSize: '2.5rem'}} />,
  85: <WiNightAltSnowWind   style={{ fontSize: '2.5rem'}} />,
  86: <WiNightAltSnowWind  style={{ fontSize: '2.5rem'}} />,
};


function getIconForHour(code, hour, sunrise, sunset) {

  const h = Number(hour.slice(0, 2));
  const sr = Number(sunrise.slice(0, 2));
  const ss = Number(sunset.slice(0, 2));

  const isDay = h >= sr && h <= ss;

  if (isDay) return <span>{weatherIconsDay[code]}</span>;

  // jeśli noc, podmień tylko 0/1/2 (pogoda słoneczna)
  if (dayToNight[code]) return <span>{dayToNight[code]}</span>

  return <span>{weatherIconsDay[code]}</span> // reszta bez zmian

}


const getDayName = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pl-PL', { weekday: 'short' }); // zwraca np. "pon."
};


function describeUV(index) {
  if (index <= 2) return  <span style={{color: '#7FE6A2'}}>Bezpiecznie</span>;
  if (index <= 5) return <span style={{color: '#6CCFF6'}}>Umiarkowane</span>;
  if (index <= 7) return <span style={{color: '#F7E27B'}}>Wysokie</span>;
  if (index <= 10) return <span style={{color: '#F7B267'}}>Niebezpieczne</span>;
  return <span style={{color: "#F26A6A"}}>B. niebezpieczne</span>;
}


  let content = <p><em>...</em> </p>

  if( data.place && !data.err){

    content = (
      
      <div className={`${styles.contentDiv} userSelectNone`}>

        <p className={styles.peakName}><em>{ data.place} ( {data.elevation} m n.p.m.)</em>  </p>
        <p className={styles['info-click-day-p']}>*Naciśnij dzień, aby zobaczyc prognozę godzinową</p>
        
        {
        
        data.daily.map((day, index)=>{

          if (!dayRefs.current[index]) {
              dayRefs.current[index] = React.createRef();
          }

          const hourly = data.hourly.time.map((t, i) => ({
            time: t,
            hour: t.split("T")[1],                     // <- godzina jako "03:00"
            date: t.split("T")[0],                     // <- data jako "2025-11-20"

            temp: data.hourly.temp[i],
            feels: data.hourly.feels[i],
            precip: data.hourly.precip[i],
            wind: data.hourly.wind[i],
            wind_gusts: data.hourly.wind_gusts[i],
            visibility: data.hourly.visibility[i],
            snowfall: data.hourly.snowfall[i],
            snow_depth: data.hourly.snow_depth[i],
            storm_risk: data.hourly.storm_risk[i],
            cloudcover: data.hourly.cloudcover[i],
            freezing_height: data.hourly.freezing_height[i],
            code: data.hourly.code[i]
          }));

          const  hoursForDay = hourly.filter(hour => hour.date === day.date )

          const stormDailyMax = Math.max(
            ...hoursForDay.map(hour => hour.storm_risk)
          );

          const snowDepthDailyMax = Math.max(
            ...hoursForDay.map(snow => snow.snow_depth)
          );

          const zeroTempDailyMax = Math.min(
            ...hoursForDay.map(height => height.freezing_height)
          );

          function isFrostBelowPlace(freezingHeight, placeElevation) {
            
            if (freezingHeight === null || freezingHeight === undefined) return null;
            
            if (freezingHeight <= 1000) return null;  
            
            if(freezingHeight > placeElevation) return null
            else{
              return  `od ${freezingHeight} m`
            } 
           
          }


          const stormProbability = (value) => Math.min(100, (value / 4800) * 100)


          function waitForScrollEnd(callback) {

            let isScrolling;
            
            const onScroll = () => {
              clearTimeout(isScrolling);
              isScrolling = setTimeout(() => {
                window.removeEventListener("scroll", onScroll);
                callback();
              }, 100);
            };

            window.addEventListener("scroll", onScroll);


          }


            return(
            
              <div key={index} className={styles.dayContener}>

                <div 
                  className={styles['one-day-weather-row']} 
                  key={index} 
                  ref={dayRefs.current[index]}
                  onClick={ () => { 
                  
                   if (openDay === index) {
                      // klik w ten sam - zamknij
                      setOpenDay(null);
                      setPrevOpenDay(null);
                      return;
                    }

                    // ustaw prevOpen na aktualny otwarty
                    setPrevOpenDay(openDay);
                    // otwórz nowy od razu
                    setOpenDay(index);


                    setTimeout(() => {
                        
                      dayRefs.current[index].current.scrollIntoView({
                          behavior: "smooth",
                          block: "start"
                        });
                      
                      waitForScrollEnd(() => { setPrevOpenDay(null) }); 

                    }, 50); // czekamy aż się rozwinie
                 
                  }}
                >
                
                    <div className={`${styles['weather-box']} ${styles['weather-box-first-part']}` }  >     
                      <p> { index === 0 ? "Dziś" : (index === 1)? "Jutro" : getDayName(day.date) }</p>
                      <p> {weatherIconsDay[day.weathercode]}</p>
                      <p><FiSunrise  size={'.8rem'}/> {day.sunrise.slice(-5)}</p>
                      <p><FiSunset  size={'.8rem'}/> {day.sunset.slice(-5)}</p>
                    </div>

               
                    <div className={`${styles['weather-box']} ${styles['wind-rain-box']}`}>
                      <p>
                      <FaTemperatureArrowUp style={{verticalAlign: 'middle'}} size={'.9rem'}/><em style={{fontSize: '.5rem'}}> max </em><span style={{padding: '1px',backgroundColor: Number(day.temp_max.toFixed(0))<=0?"#4FC3F7":"#fff"}}>{Number(day.temp_max.toFixed(0))===0?0:day.temp_max.toFixed(0)} &#176;C</span>  
                      </p>
                      <p>
                        <FaTemperatureArrowDown style={{verticalAlign: 'middle'}} size={'.9rem'}/><em style={{fontSize: '.5rem'}}> min </em><span style={{backgroundColor: Number(day.temp_min.toFixed(0))<=0?"#4FC3F7":"#fff"}}>{Number(day.temp_min.toFixed(0))===0?0:day.temp_min.toFixed(0)} &#176;C</span>
                      </p>
                      <p>
                        <GiWindsock size={".9rem"} style={{ verticalAlign: "middle" }}/> {(day.wind_min * 3.6).toFixed(0)} - { (day.wind_max * 3.6).toFixed(0)} km/h</p>
                      <p>
                        <GiSunRadiations size={'.9rem'} style={{ verticalAlign: "middle" }} /> UV <span style={{fontSize: '.7rem'}}>{describeUV(day.uv_index_max)} </span>
                      </p>
                       { 
                        isFrostBelowPlace(zeroTempDailyMax , Number(data.elevation))?
                        <p>
                          <LuPickaxe size={'.9rem'} style={{ verticalAlign: "middle" }} /> 0&#176;C { isFrostBelowPlace(zeroTempDailyMax , Number(data.elevation))}
                        </p>  
                        :
                        null
                       }   
                    </div>

                    <div className={`${styles['weather-box']} ${styles['wind-rain-box']}`}>        
                      <p>💧 {Math.max(0, (day.precipitation - day.snowfall_sum)).toFixed(1)} mm</p>
                      <p>❄️ {day.snowfall_sum.toFixed(1)} cm</p>
                      <p>❄️<TfiRuler size={'1rem'}/> {(snowDepthDailyMax * 100).toFixed(1) } cm</p>
                      <p>☁️ {day.cloudcover_mean} %</p>
                      <p>🌩️ {stormProbability(stormDailyMax).toFixed(0)} %</p>
                    </div>

                 </div>
                       
                       
                  {(openDay === index || prevOpenDay === index) && (
                  
                  <div className={styles.hourContener}>
                  {
                  hoursForDay.map((hour, i) =>{
       
                      //const visibilityProbability = (value) => Math.min(100, (value / 25000) * 100)

                      if (i % 3 !== 0) return null; 

                      return(
                            <div key={i} className={Number(hour.hour.slice(0,2))>=Number(day.sunrise.slice(-5).slice(0,2)) && Number(hour.hour.slice(0,2))<=Number(day.sunset.slice(-5).slice(0,2))?`${styles['one-hour-weather-row']} ${styles.dayHoursBox}`:`${styles['one-hour-weather-row']} ${styles.nightHoursBox}`}>
                              
                              <div  className={` ${styles['weather-box']} ${styles['weather-box-first-part']}`}>
                                <p>
                                  🕓 {hour.hour.slice(0,2)}
                                </p>
                                <p>
                                  {getIconForHour(hour.code, hour.hour, day.sunrise.slice(-5), day.sunset.slice(-5))}
                                </p>                                
                              </div>

                              <div className= {styles['weather-box']}>
                                <p>
                                  <FaTemperatureQuarter size={'.9rem'} style={{ verticalAlign: "middle" }}/><span style={{backgroundColor: Number(hour.temp.toFixed(0))<=0?"#4FC3F7":"transparent"}}> {Number(hour.temp.toFixed(0))===0?0:hour.temp.toFixed(0)} &#176;C
                                      </span>
                                </p>
                                <p>
                                  <FaTemperatureQuarter size={'.9rem'} style={{ verticalAlign: "middle" }}/><em style={{fontSize: '.5rem'}}> odcz. </em><span style={{backgroundColor: Number(hour.feels.toFixed(0))<=0?"#4FC3F7":"transparent"}}>
                                        {Number(hour.feels.toFixed(0))===0?0:hour.feels.toFixed(0)} &#176;C
                                      </span>
                                </p>
                                <p> <GiWindsock size={'.9rem'} style={{ verticalAlign: "middle" }} /> {(hour.wind * 3.6).toFixed(0)} km/h
                                </p>
                                 { 
                                 isFrostBelowPlace(hour.freezing_height, Number(data.elevation))?
                                 <p>
                                  <LuPickaxe size={'.9rem'} style={{ verticalAlign: "middle" }} /> 0&#176;C  {isFrostBelowPlace(hour.freezing_height, Number(data.elevation))}
                                 </p>:
                                 null 
                                 } 
                              </div> 

                              <div className={styles['weather-box']}>
                                  <p>💧 {Math.max(0, hour.precip - hour.snowfall).toFixed(1)} mm</p>
                                  <p>❄️ {hour.snowfall.toFixed(1)} cm</p>
                                  <p>🌩️ {stormProbability(hour.storm_risk).toFixed(0)} %</p>
                              </div>                         

                            </div>    
                      )
                      
                    })
                  }
                </div>
                  )}
                
                </div>

            )
             
          })
        }
         
    </div>
    )
  }

  return(
   <div ref={namePlaceRef} className={styles.result} style={{minHeight: '100vh'}}>
    { data.err ? <p className='userSelectNone'>Brak pogody dla nazwy: {data.place} </p> : content }  
   </div>
  )

}

export default View